import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IRoomCategory } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { JVCheckbox } from "../../shared/JVCheckbox";

const schema = yup.object({
    title: yup.string().required("Title is required"),
    beds: yup.string().required("Bed is required"),
    bathrooms: yup.string().required("Bathrooms is required"),
    area: yup.string().required("Area is required"),
    rate: yup.string().required("Rate is required"),
    keyFeatures: yup.string().required("Key Features is required"),
    wifi: yup.boolean().nullable(),
    description: yup.string().nullable()
});

interface Iprops {
    singleData: IRoomCategory,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);
    const [description, setDescription] = useState("");

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IRoomCategory>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        reset(props.singleData);
        setDescription(props.singleData.description ?? "")
    }, [props.singleData]);

    const saveToDB = async (body: IRoomCategory) => {
        body.description = description
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(`RoomCategory${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: any) {
        if (description === "" || description === null) {
            props.toast.current?.show({ severity: 'error', detail: "Description field is required", life: 3000 });
        } else {
            saveToDB(data);
        }
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '600px' }} header="Add/Edit Room Category" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required column={2} label="Title" control={control} name="title" error={errors.title?.message} />
                <JVInput required column={2} label="No. Of Beds" control={control} name="beds" error={errors.beds?.message} />
                <JVInput required column={2} label="No. Of Bathrooms" control={control} name="bathrooms" error={errors.bathrooms?.message} />
                <JVInput required column={2} label="Area" control={control} name="area" error={errors.area?.message} />
                <JVInput required column={2} label="Rate" control={control} name="rate" error={errors.rate?.message} />
                <JVInput required column={2} label="Key Features" control={control} name="keyFeatures" error={errors.keyFeatures?.message} />
                <JVCheckbox required column={2} label="Wifi" control={control} name="wifi" error={errors.wifi?.message} />
                <div className="flex flex-column w-12 ml-2">
                    <label htmlFor="">Description:<span style={{ color: 'red' }}>*</span></label>
                    <CKEditor editor={ClassicEditor} data={description} onChange={(event, editor) => { setDescription(editor.getData()); }} />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}